import { AxiosRequestConfig } from 'axios';
import { apiClient } from '@/services/apiClient';

// Orval custom instance - delegates to existing apiClient singleton
// so that Orval-generated hooks inherit Clerk JWT auth, BE envelope
// unwrapping, and error handling. The .data access extracts from
// AxiosResponse, not the BE envelope (already unwrapped by interceptor).
//
// URL prefix: Backend uses globalPrefix('api') + enableVersioning({defaultVersion:'1'})
// → all paths are /api/v1/<path>. OpenAPI spec has servers:[] so paths lack the prefix.
// We prepend /api/v1 here so Orval-generated hooks resolve correctly.
const API_PREFIX = '/api/v1';

export const customInstance = async <T>(
  config: AxiosRequestConfig
): Promise<T> => {
  if (!config.url) {
    throw new Error('API request attempted without a URL path');
  }
  const prefixedConfig: AxiosRequestConfig = {
    ...config,
    url: `${API_PREFIX}${config.url}`,
  };
  const response = await apiClient.request<T>(prefixedConfig);
  return response.data;
};

export default customInstance;
